import { Component, input } from '@angular/core';

import { LandingText } from '../landing.types';
import { LandingGlow } from './landing-glow.component';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-challenge',
    standalone: true,
    imports: [LandingGlow, RevealOnScrollDirective],
    templateUrl: './landing-challenge.component.html',
    styleUrl: './landing-challenge.component.scss'
})
export class LandingChallenge {
    readonly text = input.required<LandingText>();

    // One icon per card, matching the order of challengeCards.
    readonly challengeIcons = ['pi-pencil', 'pi-hourglass', 'pi-exclamation-triangle', 'pi-clone', 'pi-link', 'pi-calculator'];
}
